import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import locationActions from 'actions/locations'
import assetCategoryActions from 'actions/assetCategories'
import assetActions from 'actions/assets'
import Component from 'components/Jobs/FormView/CreateFromTemplate/Filter'

const mapStateToProps = (state, props) => ({ ...createAuthStateToProps(state, props) })

const mapDispatchToProps = {
  getLocations: locationActions.getItemsOffline,
  getAssetCategories: assetCategoryActions.getItemsOffline,
  getAssets: assetActions.getOptionsOffline,
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)
